import { render, staticRenderFns } from "./SearchData.vue?vue&type=template&id=a622c89c&scoped=true&"
import script from "./SearchData.vue?vue&type=script&lang=js&"
export * from "./SearchData.vue?vue&type=script&lang=js&"
import style0 from "./SearchData.vue?vue&type=style&index=0&id=a622c89c&prod&lang=scss&scoped=true&"
import style1 from "./SearchData.vue?vue&type=style&index=1&id=a622c89c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a622c89c",
  null
  
)

export default component.exports